import React, { useEffect, useState } from "react";
import { FaPencil } from "react-icons/fa6";
import { FaBan, FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";

const dsaswoPath = (userId) =>
  `${BaseUrl}/api/hod/dsaswo/${encodeURIComponent(userId)}`;

const DsaswoManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dsaswoList, setDsaswoList] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentEdit, setCurrentEdit] = useState(null);

  const fetchAll = async () => {
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    dispatch(isloading());
    try {
      const listRes = await AxiosInstance.get(`${BaseUrl}/api/hod/dsaswo`);
      setDsaswoList(listRes.data?.data || []);
    } catch (error) {
      handleAxiosError(error);
      toast.error(error.response?.data?.message || "Failed to load DSASWO data.");
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleEdit = (row) => {
    if (!row.userId) {
      toast.error("No login account linked for this district.");
      return;
    }
    setCurrentEdit({
      userId: row.userId,
      districtName: row.districtName,
      name: row.name || "",
      mobileNumber: row.mobileNumber || "",
      email: row.email || "",
    });
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (
      !currentEdit?.name?.trim() ||
      !currentEdit?.mobileNumber?.trim() ||
      !currentEdit?.email?.trim()
    ) {
      toast.error("Name, mobile number and email are required.");
      return;
    }
    if (!/^[0-9]{10}$/.test(currentEdit.mobileNumber.trim())) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }
    dispatch(isloading());
    try {
      const res = await AxiosInstance.put(dsaswoPath(currentEdit.userId), {
        name: currentEdit.name.trim(),
        mobileNumber: currentEdit.mobileNumber.trim(),
        email: currentEdit.email.trim(),
      });
      if (res.data?.status === 200) {
        toast.success(res.data.message);
        setIsEditModalOpen(false);
        fetchAll();
      } else {
        toast.error(res.data?.message || "Failed to update.");
      }
    } catch (error) {
      handleAxiosError(error);
      toast.error(error.response?.data?.message || "Failed to update.");
    } finally {
      dispatch(isloading());
    }
  };

  const confirmStatusChange = (row, active) => {
    if (!row.userId) {
      toast.error("No login account linked for this district.");
      return;
    }
    const action = active ? "Enable" : "Disable";
    const toastId = toast.warn(
      <div style={{ textAlign: "center" }}>
        <p style={{ fontWeight: "bold" }}>
          {action} DSASWO login for {row.districtName}?
        </p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => applyStatusChange(row.userId, active, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      { autoClose: false, closeOnClick: false, closeButton: false }
    );
  };

  const applyStatusChange = async (userId, active, toastId) => {
    toast.dismiss(toastId);
    dispatch(isloading());
    try {
      const res = await AxiosInstance.patch(`${dsaswoPath(userId)}/status`, {
        active,
      });
      if (res.data?.status === 200) {
        toast.success(res.data.message);
        fetchAll();
      } else {
        toast.error(res.data?.message || "Failed to update status.");
      }
    } catch (error) {
      handleAxiosError(error);
      toast.error(error.response?.data?.message || "Failed to update status.");
    } finally {
      dispatch(isloading());
    }
  };

  return (
    <div className="home-dashboard">
      <div className="ticket-tab">
        <h3 className="mb-4">DSASWO Management (District Logins)</h3>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>District</th>
                <th>Login ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Status</th>
                <th style={{ width: "12%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dsaswoList.length > 0 ? (
                dsaswoList.map((row, index) => (
                  <tr key={row.districtId}>
                    <td>{index + 1}</td>
                    <td>{row.districtName}</td>
                    <td>{row.userId || "—"}</td>
                    <td>{row.name || "—"}</td>
                    <td>{row.mobileNumber || "—"}</td>
                    <td>{row.email || "—"}</td>
                    <td>
                      {!row.userId ? (
                        <span className="badge bg-warning text-dark">Not linked</span>
                      ) : row.active ? (
                        <span className="badge bg-success">Active</span>
                      ) : (
                        <span className="badge bg-secondary">Disabled</span>
                      )}
                    </td>
                    <td>
                      {row.userId && (
                        <>
                          <FaPencil
                            className="me-3"
                            title="Update details"
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => handleEdit(row)}
                          />
                          {row.active ? (
                            <FaBan
                              title="Disable login"
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => confirmStatusChange(row, false)}
                            />
                          ) : (
                            <FaCheck
                              title="Enable login"
                              style={{ cursor: "pointer", color: "green" }}
                              onClick={() => confirmStatusChange(row, true)}
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No districts found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isEditModalOpen}
        toggle={() => setIsEditModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setIsEditModalOpen(false)}>
          Update DSASWO — {currentEdit?.districtName}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label className="form-label">
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={currentEdit?.name || ""}
              onChange={(e) =>
                setCurrentEdit((prev) => ({ ...prev, name: e.target.value }))
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              Mobile Number (OTP contact) <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              maxLength={10}
              value={currentEdit?.mobileNumber || ""}
              onChange={(e) =>
                setCurrentEdit((prev) => ({
                  ...prev,
                  mobileNumber: e.target.value,
                }))
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={currentEdit?.email || ""}
              onChange={(e) =>
                setCurrentEdit((prev) => ({ ...prev, email: e.target.value }))
              }
            />
          </div>
        </ModalBody>
        <ModalFooter className="flex-nowrap">
          <Button color="success" onClick={handleUpdate}>
            Save Changes
          </Button>
          <Button color="secondary" onClick={() => setIsEditModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DsaswoManagement;
